var e = {
	header: {
		meta: "{{type}} · Sleeps {{guests}} · {{beds}} · {{bathrooms}}",
		beds_one: "{{count}} bed",
		beds_other: "{{count}} beds",
		addRatePlan: "Add rate plan",
		actions: "Room type actions",
		edit: "Edit room type",
		addRooms: "Add rooms",
		editAmenities: "Edit amenities",
		delete: "Delete room type"
	},
	kpis: {
		title: "Last 30 nights",
		empty: "No stays in this period"
	},
	gallery: { title: "Photos" },
	ratePlans: {
		title: "Rate plans",
		add: "Add rate plan",
		emptyTitle: "No rate plans yet",
		emptyBody: "A room type can't be booked until it has a rate plan with a price."
	},
	rooms: {
		title: "Rooms",
		add: "Add rooms",
		open: "Open {{room}}",
		emptyTitle: "No rooms yet",
		emptyBody: "Add the physical rooms guests are given at check-in."
	},
	amenities: {
		title: "Amenities",
		edit: "Edit",
		empty: "No amenities chosen for this room type yet."
	},
	availability: {
		title: "Rates & availability",
		body: "Prices, minimum stays and closed dates for this room type, night by night.",
		open: "Open the rates grid"
	},
	notFound: {
		title: "Room type not found",
		body: "It may have been deleted, or you no longer have access to its property."
	},
	loadError: "We couldn't load this room type.",
	retry: "Try again"
};
//#endregion
export { e as default };
